<template>
  <v-dialog
      :value="value"
      persistent
      fullscreen
      hide-overlay
  >
    <v-card>
      <iframe
          :src="src"
          class="profile-iframe"
      />
    </v-card>
    <StopApplyingDialog v-model="stopApplyingDialog" @stopEdit="handleStopEdit" />
  </v-dialog>
</template>

<script>
import ComponentMixin from "@/components/ComponentMixin";
import {mapGetters} from "vuex";
import ApiMixin from "@/ApiMixin"
import StopApplyingDialog from "@/components/organisms/StopApplyingDialog"

export default {
  mixins: [ApiMixin, ComponentMixin],
  type: "organisms",
  name: "ProfileRegisterDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    }
  },
  components: { StopApplyingDialog },
  mounted() {
    window.addEventListener("message", this.receiveMessage)
  },
  data() {
    return {
      stopApplyingDialog: false
    }
  },
  computed: {
    ...mapGetters("jobs", ["job"]),
    type() {
      if(this.job.side) {
        return "side_job"
      } else {
        return "main_job"
      }
    },
    src() {
      return this.toProfile(`/profile/${this.type}`)
    }
  },
  methods: {
    receiveMessage(event) {
      if (event.origin !== process.env.VUE_APP_NISHIKA_PROFILE_URL) {
        return
      }
      if (event.data === 'close') {
        this.stopApplyingDialog = true
      }
      if (event.data === "confirm") {
        this.$emit("close")
        this.loadUser()
        return
      }
    },
    handleClose() {
      this.stopApplyingDialog = true
    },
    handleStopEdit() {
      this.$emit("close")
      this.loadUser()
    }
  }
}
</script>

<style scoped>
.profile-iframe {
  width: 100%;
  height: calc(100vh - 8px);
}
</style>
